import { render, staticRenderFns } from "./Sugerencia.vue?vue&type=template&id=12148daf&"
import script from "./Sugerencia.vue?vue&type=script&lang=js&"
export * from "./Sugerencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports